import React from 'react';
import "./ActingCourses.css";
import "./TheaterGroup.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper';
import { Button, Form, Input } from 'antd';
import styleImage from "../../Images/play.png";
import { TiStarburst } from "react-icons/ti";

import theatergroup from "../../Images/Courses/theater group 1.jpg";
import theatergroup1 from "../../Images/Courses/theater group 2.jpg";
import theatergroup2 from "../../Images/Courses/theater group 3.jpg";
import theatergroup3 from "../../Images/Courses/theater group 4.jpg";
import theatergroup4 from "../../Images/Courses/theater group 6.jpg";
import theatergroup5 from "../../Images/Courses/theater group 7.jpg";
import FooterComponent from '../FooterComponent';
import $ from 'jquery';
import TextArea from 'antd/es/input/TextArea';

const TheaterGroup = () => {
    const [form] = Form.useForm();

    const submitFrom = (values) => {
        var body = '<!DOCTYPE html><html><head><title>Enquiry Lead</title></head><body><div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;background-color:#f2f2f2;padding:20px"><h2 style="color:#821f40">ABSS</h2><p>Hello</p><p>Thank you for your interest in our products/services.</p><p>Please check your enquiry which generated from website:</p><table cellpadding="5" style="margin:0"><tr><td style="text-align:left;color:#821f40"><strong>Name:</strong></td><td style="text-align:left">' + values.name + '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Courses:</strong></td><td style="text-align:left">' + values.courses + '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Contact No:</strong></td><td style="text-align:left">' + values.contact + '</td></tr><tr><td style="text-align:left;color:#821f40"><strong>Message:</strong></td><td style="text-align:left">' + values.message + '</td></tr></table><p style="font-weight:700">Best regards,<br>Your Team at ABSS</p></div></body></html>';

        $.post("https://skdm.in/server/v1/send_lead_mail.php", {
            toEmail: "info@abssgroup.com",
            fromEmail: "skdmlead@gmail.com",
            bccMail: "skdmlead@gmail.com",
            mailSubject: "New Customer Lead",
            mailBody: body,
            accountName: "ABSS",
            accountLeadSource: "https://abssgroup.com/",
            accountLeadName: values.name,
            accountLeadEmail: values.email,
            accountLeadPhone: values.contact,
        },

            function (dataa, status) {
                console.log('data :' + dataa);
                console.log("name:" + values);
            });

        alert("Your Form has Submitted Our team will contact with You  soon.");
        form.resetFields();
        values.preventDefault()
        return false;
    }

    return (
        <>
            <section className='acting-courses-section-1-main-con theatergroup-section-1-back-image'>
                <div className='acting-courses-section-banner-con'>
                    {/* <div className='action-courses-section-text'>
                        <h1>Theater Group</h1>
                        <h2>Theater Group</h2>
                    </div> */}
                </div>
            </section>

            <section className='acting-courses-section-2'>
                <div className='container'>
                    <div className='acting-courses-section-2-main-con'>
                        <div className='row'>
                            <div className='col-md-8'>
                                <div className='acting-courses-section-2-details-main-con'>
                                    <div className='acting-courses-section-2-details'>
                                        <Swiper
                                            spaceBetween={30}
                                            centeredSlides={true}
                                            autoplay={{
                                                delay: 2500,
                                                disableOnInteraction: false,
                                            }}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            navigation={true}
                                            modules={[Autoplay, Pagination, Navigation]}
                                            className="mySwiper"
                                        >
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup1} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup2} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup3} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup4} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <div className='acting-courses-section-2-swiper'>
                                                    <div className='acting-courses-section-2-details-images'>
                                                        <img src={theatergroup5} alt='actingcourses' />
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>

                                    <div className='acting-courses-section-2-details-text-con'>
                                        <div className='theater-group-section-2-details-text-con'>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>A comprehensive approach to theatre encompassing:</h3>
                                                </div>
                                                <ul>
                                                    <li>Meditation</li>
                                                    <li>Imagination</li>
                                                    <li>Improvisation</li>
                                                    <li>Observation</li>
                                                    <li>Facial expressions</li>
                                                    <li>Body language</li>
                                                    <li>Diction</li>
                                                    <li>Voice modulation</li>
                                                    <li>Camera techniques</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Daily sessions involving:</h3>
                                                </div>
                                                <ul>
                                                    <li>Intensive practice of theatre plays based on scripts</li>
                                                    <li>Activities such as story reading, character analysis, and psychological exploration</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Character development through:</h3>
                                                </div>
                                                <ul>
                                                    <li>Blocking rehearsals</li>
                                                    <li>Focus on body language, reactions, emotions, and costume-props</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Character development through:</h3>
                                                </div>
                                                <ul>
                                                    <li>Blocking rehearsals</li>
                                                    <li>Focus on body language, reactions, emotions, and costume-props</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Rehearsals tailored to mimic camera patterns, preparing for both stage and screen performances</h3>
                                                </div>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Shows staged in various cities across India, extending beyond Mumbai</h3>
                                                </div>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Annual theatre festival, the Gandhi Jayanti Natya Mahotsav:</h3>
                                                </div>
                                                <ul>
                                                    <li>Provides a platform for aspiring actors</li>
                                                    <li>Celebrates the rich cultural heritage of theatre</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Enriching journey fostering:</h3>
                                                </div>
                                                <ul>
                                                    <li>Creativity</li>
                                                    <li>Skill development</li>
                                                    <li>Dreams taking center stage</li>
                                                </ul>
                                            </div>

                                            <div className='theater-group-section-2-details-text'>
                                                <div className='theater-group-section-2-details-head-con'>
                                                    <div className='theater-group-section-2-details-icons'>
                                                        <TiStarburst />
                                                    </div>
                                                    <h3>Designed to nurture talent, foster artistic expression, and instill appreciation for the transformative power of theatre.</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-4'>
                                <div className='stock-details-section-2-right-side-main-con'>
                                    <div className='stock-details-2-right-side-form'>
                                        <div className='stock-details-2-right-side-form-title'>
                                            <h3>Theater Group</h3>
                                        </div>
                                        <div className='stock-details-2-right-side-form-price'>
                                            <div className='stock-details-2-form-price-and-quent'>
                                            <Form
                                                    layout='vertical'
                                                    initialValues={{
                                                        courses: 'Theater Group'
                                                    }}
                                                    onFinish={submitFrom}
                                                >
                                                    <Form.Item name="name" label="Name">
                                                        <Input
                                                            placeholder='Name'
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="contact" label="Contact">
                                                        <Input
                                                            placeholder='Contact No.'
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="courses" label="Courses Name">
                                                        <Input
                                                            placeholder='Courses'
                                                            disabled
                                                        />
                                                    </Form.Item>
                                                    <Form.Item name="message" label="Message">
                                                        <TextArea
                                                        rows={4}
                                                            placeholder='Message'
                                                        />
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <Button htmlType='submit'>
                                                            Enquire Now
                                                        </Button>
                                                    </Form.Item>
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <FooterComponent/>
        </>
    )
}

export default TheaterGroup